import React, { Component } from "react";
import { getBranch, getRegion, getDepartment, main_url, getFirstDayOfMonth } from '../../utils/CommonFunction';
import DatePicker from 'react-datetime';
import moment from "moment";
import Select from "react-select";
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import 'jspdf-autotable';
import { getHeaders } from "../../utils/apiHelper";
const $ = require('jquery');
const jzip = require('jzip');
window.JSZip = jzip;
$.DataTable = require('datatables.net-bs4');
$.DataTable = require('datatables.net-responsive-bs4');
$.DataTable = require('datatables.net');
require('datatables.net-buttons/js/dataTables.buttons.min');
require('datatables.net-buttons/js/buttons.html5.min');


class LateCheckInReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch: [],
      region: [],
      department: [],
      branchId: null,
      regionId: null,
      departmentId: null,
      from_date: moment(getFirstDayOfMonth()),
      to_date: moment(),

    }
  }

  async componentDidMount() {
    this.$el = $(this.el);
    this.setState(
      {
        dataSource: this.props.data,

      },
      () => {
        this._setTableData(this.state.dataSource);
      }
    );


    let branch = await getBranch();
    branch.unshift({ label: 'All', value: 0 });
    let department = await getDepartment();
    department.unshift({ label: 'All', value: 0 });
    let region = await getRegion();
    region.unshift({ state_name: 'ALL', state_id: 0 });
    this.setState({
      branch: branch,
      department: department,
      region: region.map(v => ({ ...v, label: v.state_name, value: v.state_id })),

    })
    this.handleSearchData();
  }
  handleSelectedBranch = async (event) => {
    this.setState({
      branchId: event
    })
  }

  handleSelectedDepartment = async (event) => {
    this.setState({
      departmentId: event
    })
  }
  handleSelectedRegion = async (event) => {
    this.setState({
      regionId: event
    })
  }
  handleSelectedFromdate = async (event) => {
    this.setState({
      from_date: event
    })
  }
  handleSelectedTodate = async (event) => {
    this.setState({
      to_date: event
    })
  }
  handleSearchData = () => {
    fetch(`${main_url}attendance/lateCheckInReport/${this.state.branchId ? this.state.branchId.value : 0}/${this.state.departmentId ? this.state.departmentId.value : 0}/${this.state.regionId ? this.state.regionId.value : 0}/${moment(this.state.from_date).format("YYYY-MM-DD")}/${moment(this.state.to_date).format("YYYY-MM-DD")}`, {
      headers: getHeaders(),
    })
      .then(res => { if (res.ok) return res.json() })
      .then(list => {
        this._setTableData(list);
      })
  }

  _setTableData = (data) => {
    var table;
    var l = [];
    if (data) {
      for (var i = 0; i < data.length; i++) {
        let result = data[i];
        let application_status = '';
        let obj = [];
        if (result.late_checkin_reason != null) {
          if (result.status === 0) {
            application_status = '<small class="label label-warning" style="background-color:#509aed"> Request  </small>'
          } else if (result.status === 1) {
            application_status = '<small class="label label-warning" style="background-color:#29a50a"> Approve  </small>'
          } else {
            application_status = '<small class="label label-warning" style="background-color:#29a50a"> Reject  </small>'
          }
        } else {
          application_status = '-'
        }

        obj = {
          no: i + 1,
          date: data[i].createdAt ? moment.parseZone(data[i].createdAt).format('YYYY-MM-DD') : '-',
          employee_id: data[i].employment_id ? data[i].employment_id : "-",
          employee_name: data[i].fullname ? data[i].fullname : "-",
          branch: data[i].location_master_name ? data[i].location_master_name : "-",
          designation: data[i].designations ? data[i].designations : "-",
          checkIn: data[i].check_in_time ? moment.parseZone(data[i].check_in_time).format('YYYY-MM-DD hh:mm:ss a') : "-",   // Added by STHA 2023-July-06
          checkOut: data[i].check_out_time ? moment.parseZone(data[i].check_out_time).format('YYYY-MM-DD hh:mm:ss a') : "-", // Added by STHA 2023-July-06
          workingHour: data[i].working_hour ? data[i].working_hour : '-',
          lateMin: data[i].late_mins ? data[i].late_mins : '-',
          reason: data[i].late_checkin_reason ? data[i].late_checkin_reason : '-',
          status: application_status
        }

        l.push(obj)
      }
    }
    if ($.fn.dataTable.isDataTable('#dataTables-table')) {
      table = $('#dataTables-table').dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $('#dataTables-table').empty();
    }
    var column = [
      { title: "Sr No", data: "no" },
      { title: "Date", data: 'date' },
      { title: "Employee Id", data: "employee_id" },
      { title: "Employee Name", data: "employee_name" },
      { title: "Position", data: "designation" },
      { title: "Branch", data: "branch" },
      { title: "Late Check in", data: "checkIn" },
      { title: "Check Out", data: "checkOut" },
      { title: "Working Hour", data: "workingHour" },
      { title: "Late Min", data: "lateMin" },
      { title: "Reason", data: "reason" },
      { title: "Status", data: "status" },

    ]
    table = $("#dataTables-table").DataTable({

      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      pageLength: 50,
      paging: true,
      buttons: true,
      dom: 'Bfrtip',
      buttons: [
        'excel'
        //     //     'copy', 'csv', 'excel', 'pdf'
      ],
      buttons: [
        //         // 'copy',
        //         // {
        //         //         extend: 'csvHtml5',
        //         //         title: 'Child Benefit',
        //         // },
        {
          extend: 'excelHtml5',
          title: 'Late CheckIn Report',
        },
        //         // {
        //         //     extend: 'pdfHtml5',
        //         //     title: 'Child Benefit',
        //         // }
      ],
      data: l,
      columns: column
    });
  }


  render() {

    return (
      <div>
        <div className="row  white-bg dashboard-header">
          <h3 className="" style={{ paddingLeft: "10px" }}>Late Check-In Report</h3>
          <div className='flex-row' style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', margin: '10px 10px 10px 10px' }}>
            <div style={{ marginRight: 10, width: 150 }}>
              <DatePicker
                dateFormat="DD/MM/YYYY"
                value={this.state.from_date}
                onChange={this.handleSelectedFromdate}
                timeFormat={false}
              />
            </div>
            <div style={{ marginRight: 10, width: 150 }}>
              <DatePicker
                dateFormat="DD/MM/YYYY"
                value={this.state.to_date}
                onChange={this.handleSelectedTodate}
                timeFormat={false}
              />
            </div>
            <Select
              styles={{
                container: base => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                  marginRight: 10
                }),
                control: base => ({
                  ...base,
                  minHeight: '18px'
                }),

              }}
              placeholder="Branch"
              options={this.state.branch}
              onChange={this.handleSelectedBranch}
              value={this.state.branchId}
              className='react-select-container'
              classNamePrefix="react-select"
            />
            <Select
              styles={{
                container: base => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                  marginRight: 10
                }),
                control: base => ({
                  ...base,
                  minHeight: '18px'
                }),

              }}
              placeholder="Region"
              options={this.state.region}
              onChange={this.handleSelectedRegion}
              value={this.state.regionId}
              className='react-select-container'
              classNamePrefix="react-select"
            />

            <Select
              styles={{
                container: base => ({
                  ...base,
                  //   flex: 1
                  width: 150
                }),
                control: base => ({
                  ...base,
                  minHeight: '18px'
                }),

              }}
              placeholder="Department"
              options={this.state.department}
              onChange={this.handleSelectedDepartment}
              value={this.state.departmentId}
              className='react-select-container'
              classNamePrefix="react-select"
            />
            <button className='btn btn-primary text-center' style={{ marginLeft: 10, height: 30, padding: '0px 5px 0px 5px' }} onClick={() => this.handleSearchData()}>Search</button>
          </div>

          <table width="99%"
            className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive"
            id="dataTables-table"
          />
        </div>
      </div>
    )
  }
}
export default LateCheckInReport;